import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient, ApiResponse } from '../../libs/apiClient';
import config from '../../config';
import moment from 'moment';
import $ from "jquery";

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Estatus", value: true },
    { title: "Fecha Solicitada", value: true },
    { title: "Fecha Necesaria", value: true },
    { title: "Num.Doc", value: true },
    { title: "Nivel Requerimiento", value: true },
    { title: "Sucursal", value: true },
    { title: "Área Solicitante", value: true },
    { title: "Nombre Solicitante", value: true },
    { title: "Comentarios", value: true },
    { title: "Proyecto", value: true },
    { title: "Nombre del aprobador", value: true },
    { title: "Serie", value: true },
    { title: "Borrador origen", value: true },
    { title: "F. Creado borr.", value: true },
    { title: "F. Creado firme", value: true },
];

class PurchaseRequestView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }

    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liPurchaseRequest");
        let today = moment(new Date()).format('YYYYMMDD');

        let date = {
            dateInit: today,
            dateFinal: today,
        }

        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async newDate => {

        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        let data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            switch1: newDate.docStatus || '---',
            table: "OPRQ",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--',
            isCanceled: newDate?.isCanceled || 'N',
        };

        enableSpinner(true);
        let orderSalesListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if (orderSalesListResponse.status === SERVICE_RESPONSE.SUCCESS) {


            let dataSerie = {
                docType: "1470000113",
                docSubType: "--"
            };

            enableSpinner(true);
            let seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);

            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            let ValidateSeries = user.U_FMB_ValidateSeriesOPRQ ? user.U_FMB_ValidateSeriesOPRQ : "";

            if (!user || ValidateSeries === "") {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
                });

                this.setState({
                    data: [],
                });
                return;
            }

            let seriesUsers = ValidateSeries.split("|");


            let newArraySeries = [];

            seriesUsers.map(serieUser => {
                seriesResponse.data.map(serieResponse => {
                    if (serieResponse.Series == serieUser) {
                        newArraySeries.push(serieResponse);
                    }
                })
            })

            if (newArraySeries.length === 0) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "El usuario no tiene serie permitida de escritura y lectura"
                });
                return;
            }


            let newDocumentsfilterSeries = [];

            orderSalesListResponse.data.map(document => {
                newArraySeries.map(serie => {
                    if (document.SeriesCode == serie.Series) {
                        newDocumentsfilterSeries.push(document);
                    }
                })
            });


            this.setState({
                data: newDocumentsfilterSeries,
            });
            return;
        }

    }


    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };

    render() {
        const { headers, data, updateData, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'SOLICITUD DE COMPRA'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        <a id="linkOrdProv" className="text-muted">
                            &nbsp;SOLICITUD DE COMPRA
                        </a>
                    </h2>
                    <DataTables headers={headers} view={"PurchaseRequest"} data={data} search={this.searchDocuments} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PurchaseRequestView);
